
export default {
  title: 'Réalisations',
  description: 'Suivez votre progression de planification de mariage',
  earnedPoints: 'Points gagnés',
  pointsCount: '{{earned}} / {{total}}',
  points: '{{count}} point',
  points_one: '{{count}} point',
  points_other: '{{count}} points',
  completedAt: 'Complété le {{date}}',
  unlocked: 'Réalisation débloquée !',
  continue: 'Continuer',
  
  categories: {
    all: 'Toutes',
    events: 'Événements',
    subscription: 'Abonnement',
    engagement: 'Engagement',
    social: 'Social'
  },
  
  stats: {
    pointsEarned: 'Points gagnés',
    completed: 'Complétées',
    events: 'Événements',
    level: 'Niveau',
    unlimited: 'Illimité',
    limited: 'Limité',
    pro: 'Pro',
    essential: 'Essential',
    free: 'Gratuit'
  },
  
  rarity: {
    common: 'Commun',
    rare: 'Rare',
    epic: 'Épique',
    legendary: 'Légendaire'
  },
  
  empty: {
    title: 'Aucune réalisation',
    description: 'Aucune réalisation dans cette catégorie pour le moment.'
  },
  
  ui: {
    points: 'points',
    completedOn: 'Complété le',
    noAchievements: 'Aucune réalisation dans cette catégorie pour le moment.',
    loading: 'Chargement...',
    error: 'Erreur lors du chargement des réalisations'
  },
  
  achievements: {
    firstGuest: 'Premier invité',
    firstTask: 'Première tâche',
    budgetSet: 'Budget défini',
    firstVendor: 'Premier prestataire',
    planningMaster: 'Maître planificateur',
    organized: 'Organisé',
    budgetWise: 'Économe',
    socialite: 'Sociable',
    taskMaster: 'Maître des tâches',
    timeKeeper: 'Gardien du temps'
  },
  
  titles: {
    'Premier Pas': 'Premier Pas',
    'Organisateur Multi-événements': 'Organisateur Multi-événements',
    'Maître des Célébrations': 'Maître des Célébrations',
    'Légende de l\'Organisation': 'Légende de l\'Organisation',
    'Cupide du Mariage': 'Cupide du Mariage',
    'Roi de la Fête': 'Roi de la Fête',
    'Maître des Fiançailles': 'Maître des Fiançailles',
    'Spécialiste Baby Shower': 'Spécialiste Baby Shower',
    'Organisateur Spirituel': 'Organisateur Spirituel',
    'Maître de Tous les Arts': 'Maître de Tous les Arts',
    'Utilisateur Fidèle': 'Utilisateur Fidèle',
    'Expert Premium': 'Expert Premium',
    'Liberté Illimitée': 'Liberté Illimitée',
    'Supporter de Wedora': 'Supporter de Wedora',
    'Planificateur Assidu': 'Planificateur Assidu',
    'Accro à l\'Organisation': 'Accro à l\'Organisation',
    'Perfectionniste': 'Perfectionniste',
    'Ambassadeur Wedora': 'Ambassadeur Wedora',
    'Ambassadeur WedBox': 'Ambassadeur WedBox',
    'Mentor': 'Mentor',
    'Organisateur débutant': 'Organisateur débutant',
    'Organisateur confirmé': 'Organisateur confirmé',
    'Maître organisateur': 'Maître organisateur',
    'Premier invité': 'Premier invité',
    'Mariage intime': 'Mariage intime',
    'Grande célébration': 'Grande célébration',
    'Planificateur économe': 'Planificateur économe',
    'Gestionnaire avisé': 'Gestionnaire avisé',
    'Expert financier': 'Expert financier',
    'Chroniqueur débutant': 'Chroniqueur débutant',
    'Maître du temps': 'Maître du temps',
    'Bienvenue !': 'Bienvenue !',
    'C\'est parti !': 'C\'est parti !',
    'Supporter de WedBox': 'Supporter de WedBox'
  },
  
  descriptions: {
    'Créez votre premier événement': 'Créez votre premier événement',
    'Gérez 3 événements différents': 'Gérez 3 événements différents',
    'Créez 5 événements différents': 'Créez 5 événements différents',
    'Gérez 10 événements ou plus': 'Gérez 10 événements ou plus',
    'Organisez votre premier mariage': 'Organisez votre premier mariage',
    'Organisez 3 anniversaires': 'Organisez 3 anniversaires',
    'Organisez une cérémonie de fiançailles': 'Organisez une cérémonie de fiançailles',
    'Organisez un baby shower': 'Organisez un baby shower',
    'Organisez un baptême': 'Organisez un baptême',
    'Organisez au moins un événement de chaque type': 'Organisez au moins un événement de chaque type',
    'Passez au plan Essential': 'Passez au plan Essential',
    'Passez au plan Pro': 'Passez au plan Pro',
    'Profitez des événements illimités du plan Pro': 'Profitez des événements illimités du plan Pro',
    'Restez abonné pendant 3 mois': 'Restez abonné pendant 3 mois',
    'Connectez-vous 7 jours consécutifs': 'Connectez-vous 7 jours consécutifs',
    'Connectez-vous 30 jours consécutifs': 'Connectez-vous 30 jours consécutifs',
    'Complétez 100% des tâches d\'un événement': 'Complétez 100% des tâches d\'un événement',
    'Partagez votre expérience sur les réseaux sociaux': 'Partagez votre expérience sur les réseaux sociaux',
    'Aidez un autre utilisateur avec vos conseils': 'Aidez un autre utilisateur avec vos conseils',
    'Complétez 5 tâches': 'Complétez 5 tâches',
    'Complétez 15 tâches': 'Complétez 15 tâches',
    'Complétez 50 tâches': 'Complétez 50 tâches',
    'Ajoutez votre premier invité': 'Ajoutez votre premier invité',
    'Ajoutez 20 invités': 'Ajoutez 20 invités',
    'Ajoutez 100 invités': 'Ajoutez 100 invités',
    'Créez votre premier budget': 'Créez votre premier budget',
    'Ajoutez 5 dépenses': 'Ajoutez 5 dépenses',
    'Restez dans les limites de votre budget': 'Restez dans les limites de votre budget',
    'Ajoutez votre premier événement au planning': 'Ajoutez votre premier événement au planning',
    'Planifiez tous les événements importants': 'Planifiez tous les événements importants',
    'Créez votre compte Wedora': 'Créez votre compte Wedora',
    'Créez votre compte WedBox': 'Créez votre compte WedBox',
    'Complétez l\'onboarding': 'Complétez l\'onboarding'
  }
}; 